import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonTenantOverviewViews, CommonTenantTopics } from "../../CommonComponents/CommonTenantOverviewViews";

export const TenantOverviewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.tenant.overview,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonTenantOverviewViews />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonTenantTopics />;
    },
};
